.switchLabel:global(.MuiTypography-root) {
	font-size: 14px;
	align-self: center;
	text-align: right;
	white-space: nowrap;
	line-height: 20px;
	font-weight: 400;
}

.switchRow {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
}
